import React, { FC, ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { body2 } from '@westwing/ui-kit/typography';

const accountSectionCss = css`
    background: ${({ theme }) => theme.colors.charcoal100};
    color: ${({ theme }) => theme.colors.white};
    padding-bottom: 80px;
`;

const MenuSectionWrapper = styled.section<{ isFullWidthSection: boolean; bordered?: boolean; search?: boolean }>`
    ${({ search }) =>
        search
            ? css`
                  border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
              `
            : ''}
    color: ${({ theme }) => theme.colors.charcoal100};
    ${({ isFullWidthSection }) => (isFullWidthSection ? accountSectionCss : ' margin: 0 20px;')}
    ${({ bordered }) =>
        !bordered
            ? css`
                  &:last-child {
                      border-bottom: none;
                  }
              `
            : css`
                  border-top: 1px solid ${({ theme }) => theme.colors.charcoal20};
              `}
    ${forDesktop`
        margin: 0;
    `}
`;

export const StyledMenuSectionList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const StyledMenuSectionTitle = styled.div`
    ${body2}
    padding: 30px 0 20px 0;
    color: ${({ theme }) => theme.colors.charcoal100};
    border-top: 1px solid ${({ theme }) => theme.colors.charcoal20};
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
    text-align: center;
`;

export const MenuSection: FC<{ title?: string; bordered?: boolean; isFullWidthSection: boolean; search?: boolean }> = ({
    title,
    children,
    bordered,
    isFullWidthSection,
    search,
}): ReactElement => (
    <MenuSectionWrapper isFullWidthSection={isFullWidthSection} bordered={bordered} search={search}>
        {title && <StyledMenuSectionTitle>{title}</StyledMenuSectionTitle>}
        <StyledMenuSectionList>{children}</StyledMenuSectionList>
    </MenuSectionWrapper>
);

export default MenuSection;
